import React from 'react'
import State from './State'

const Toggle = ({ initial, render }) => (
  <State
    initial={{ on: initial }}
    render={({ state: { on }, setState }) =>
      render({
        on,
        enable: () => setState({ on: true }),
        disable: () => setState({ on: false }),
        toggle: () => setState(state => ({ on: !state.on })),
        set: on => setState({ on })
      })
    }
  />
)

export default Toggle



// WEBPACK FOOTER //
// ./src/components/Toggle.js